import { PayloadAction } from "@reduxjs/toolkit";
import { Visiable } from "../../../../utl/models/Visiable";
import { ClientsState } from "../models/ClientsState";

const setVisiableTransactionForm = (state: ClientsState, actions: PayloadAction<Visiable>) => {
    state.visiableTransactionForm = actions.payload.visiable;
}

export default setVisiableTransactionForm;